import React from "react";
import { Link } from "react-router-dom";

export default function ServicesPage() {
  const services = [
    {
      title: "Domestic Shipping",
      desc: "Reliable U.S. parcel delivery with verified handling, transparent timelines and nationwide coverage.",
      icon: "bi-truck",
      link: "/services/domestic"
    },
    {
      title: "International Shipping",
      desc: "Cross-border air & ocean freight with documentation support, customs guidance and shipment tracking.",
      icon: "bi-globe-americas",
      link: "/services/international"
    },
    {
      title: "E-Commerce Fulfillment",
      desc: "Pick, pack and ship services tailored for online stores — optimized for speed, accuracy and scalability.",
      icon: "bi-bag-check",
      link: "/services/e-commercefulfillment"
    },
    {
      title: "Warehousing",
      desc: "Secure storage, inventory management and distribution designed for growing businesses.",
      icon: "bi-buildings",
      link: "/services/warehousing"
    },
    {
      title: "Customs Clearance",
      desc: "Support for compliant import/export documentation and customs processing for global shipments.",
      icon: "bi-file-earmark-check",
      link: "/services/customs-clearance"
    },
    {
      title: "Bulk Freight Delivery",
      desc: "Cost-efficient freight movement for large-volume cargo with optimized routing and coordination.",
      icon: "bi-box-seam",
      link: "/services/bulk-freight"
    }
  ];

  return (
    <>
      <style>{`
        .services-banner {
          height: 320px;
          background: url('/slider1.jpg') center/cover no-repeat;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          color: white;
        }

        .services-banner::after {
          content: "";
          position: absolute;
          inset: 0;
          background: rgba(0,0,0,0.55);
        }

        .services-banner h1 {
          z-index: 2;
          font-size: 48px;
          font-weight: 800;
          animation: fadeUp 1s ease;
        }

        .section {
          padding: 90px 0;
        }

        .section-title {
          font-size: 34px;
          font-weight: 800;
          margin-bottom: 15px;
        }

        .section-sub {
          font-size: 17px;
          color: #555;
          max-width: 850px;
          margin: auto;
          line-height: 1.6;
        }

        .service-card {
          background: rgba(255,255,255,0.9);
          backdrop-filter: blur(10px);
          padding: 35px;
          border-radius: 20px;
          border: 1px solid rgba(0,0,0,0.07);
          box-shadow: 0 10px 30px rgba(0,0,0,0.10);
          transition: 0.3s ease;
          animation: fadeUp 0.9s ease forwards;
          cursor: pointer;
          height: 100%;
        }

        .service-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 18px 45px rgba(0,0,0,0.18);
        }

        .service-icon {
          font-size: 42px;
          color: #005eff;
          margin-bottom: 18px;
        }

        .service-title {
          font-size: 22px;
          font-weight: 700;
          margin-bottom: 10px;
        }

        .service-desc {
          font-size: 15.5px;
          color: #444;
          line-height: 1.55;
        }

        @keyframes fadeUp {
          0% { opacity: 0; transform: translateY(25px); }
          100% { opacity: 1; transform: translateY(0); }
        }
      `}</style>

      {/* ⭐ TOP BANNER */}
      <div className="services-banner">
        <h1>Our Logistics Services</h1>
      </div>

      {/* ⭐ SERVICES SECTION */}
      <section className="section">
        <div className="container">

          <h2 className="section-title text-center">
            End-to-End Logistics Solutions Built for Modern Businesses
          </h2>

          <p className="section-sub text-center mb-5">
            Whether you're a growing online store, an enterprise distributing nationwide,
            or a business shipping globally — SWIFTSHIP provides structured, scalable and
            compliance-focused logistics services tailored to your needs.
          </p>

          <div className="row g-4">
            {services.map((s, i) => (
              <div className="col-lg-4 col-md-6" key={i}>
                <Link to={s.link} style={{ textDecoration: "none" }}>
                  <div className="service-card">
                    <i className={`bi ${s.icon} service-icon`}></i>
                    <h4 className="service-title">{s.title}</h4>
                    <p className="service-desc">{s.desc}</p>
                  </div>
                </Link>
              </div>
            ))}
          </div>

        </div>
      </section>
    </>
  );
}
